
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => ({}),
    },
    buttonClick: {
      type: Function,
      default: null,
    },
    noLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAnchorLink: false,
      isDisabled: false,
      isExternalLink: false,

      textColor: null,
      backgroundColor: null,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.width =
        (this.blok?.type === 'fullWidth' ||
          this.blok?.type === 'fullWidth-short') &&
        '100%'
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },

    buttonStyles() {
      const styles = {}

      styles.color = this.blok.textColorOverride
      styles.background = this.blok.backgroundColorOverride
      styles.borderRadius = this.getBreakpointValue(
        this.blok?.borderRadiusOverride
      )
      styles.border = this.blok.border

      return styles
    },

    buttonClasses() {
      return {
        ' rounded-full min-h-[36px] px-4 sm:px-[30px] inline-flex justify-center items-center pt-[2px] text-sm-semibold hover:shadow-1 hover:scale-[1.02]':
          this.blok?.type === 'pill',
        'rounded-full inline-flex justify-start items-center pt-[2px] px-4 text-base-semibold min-h-[36px]':
          this.blok?.type === 'text',
        'w-full inline-flex justify-center items-center h-full min-h-[64px]':
          this.blok?.type === 'fullWidth',
        'w-full inline-flex justify-center items-center h-full min-h-[56px]':
          this.blok?.type === 'fullWidth-short',
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      // check disable from blok and prop
      this.isDisabled = !!this.blok?.disabled
      // check if anchor link
      const isAnchorLink = this.blok?.link?.url?.charAt(0) === '#'
      this.isAnchorLink = !!isAnchorLink
      // check if external link and make sure its not an anchor link
      this.isExternalLink = this.blok?.link?.url && !!isAnchorLink !== true

      this.backgroundColor = window.getComputedStyle(
        this.$refs.button
      ).backgroundColor
      this.textColor = window.getComputedStyle(this.$refs.button).color
    })
  },
  methods: {
    handleScroll($event) {
      if (this.isAnchorLink) {
        // scroll to section
        const scrollTarget = $event.target.getAttribute('data-link')

        this.$gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: scrollTarget,
            offsetY: 70,
          },
        })
      }
    },
    toggleBackgroundColor(state) {
      if (state) {
        this.$gsap.to(this.$refs.button, {
          backgroundColor: this.textColor,
          color: this.backgroundColor,
          duration: 0.1,
        })
      } else {
        this.$gsap.to(this.$refs.button, {
          backgroundColor: this.backgroundColor,
          color: this.textColor,
          duration: 0.1,
        })
      }
    },
  },
}
